(function() { window.GUID_c475cab3_47c9_4107_b150_b49ed12e311c = { getGuid: function() { return "c475cab3-47c9-4107-b150-b49ed12e311c"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let MatchesFiltersPreset;
        (function (MatchesFiltersPreset) {
            MatchesFiltersPreset[MatchesFiltersPreset["MyDivisions"] = 0] = "MyDivisions";
            MatchesFiltersPreset[MatchesFiltersPreset["MyFriends"] = 1] = "MyFriends";
            MatchesFiltersPreset[MatchesFiltersPreset["MyFavorites"] = 2] = "MyFavorites";
            MatchesFiltersPreset[MatchesFiltersPreset["Custom"] = 3] = "Custom";
        })(MatchesFiltersPreset = Enumeration.MatchesFiltersPreset || (Enumeration.MatchesFiltersPreset = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=MatchesFiltersPreset.pre.js.map
